export class PTWDialog {
  IsWithinFacilities: any;
  IsHydrocarbonArea: any;
  IsElectricalInstallations: any;
  IsConfinedSpace: any;
  IsSupplementaryCertificate: any;
  IsEmergencyPlanning: any;
  IsWorkForce: any;
  IsCompetentStaff: any;
  IsWrittenProcedure: any;
  IsPlanWritten: any;
  IsSupervisorAppointed: any;
}
